import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import Header from './components/Header';
import Footer from './components/Footer';
import Home from './pages/Home';
import About from './pages/About';
import Gallery from './pages/Gallery';
import Contact from './pages/Contact';
import Box from '@mui/material/Box';

const theme = createTheme({
  palette: {
    primary: {
      main: '#2F4F2F', // Dark green from the image
      light: '#4A7C59', // Lighter green
      dark: '#1B3D1B', // Darker green
    },
    secondary: {
      main: '#8B0000', // Dark reddish-purple from the image
      light: '#B22222', // Lighter reddish-purple
      dark: '#660000', // Darker reddish-purple
    },
    // Additional colors for the warm brown theme
    success: {
      main: '#8B4513', // Saddle Brown - warm cashew color
      light: '#CD853F', // Peru - lighter brown
      dark: '#654321', // Dark Brown
    },
    warning: {
      main: '#D2691E', // Chocolate - accent color
      light: '#DEB887', // Burlywood
      dark: '#A0522D', // Sienna
    },
    background: {
      default: '#fafafa',
    },
  },
  typography: {
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
    h1: {
      fontWeight: 700,
    },
    h2: {
      fontWeight: 600,
    },
    h3: {
      fontWeight: 600,
    },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: 'none',
          borderRadius: 8,
        },
      },
    },
  },
});

function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Router>
        <div className="App">
          <Header />
          <Box sx={{ pt: 8 }}> {/* Add top padding to account for fixed header */}
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/about" element={<About />} />
              <Route path="/gallery" element={<Gallery />} />
              <Route path="/contact" element={<Contact />} />
            </Routes>
          </Box>
          <Footer />
        </div>
      </Router>
    </ThemeProvider>
  );
}

export default App; 